import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { MAZE_STRIKER_ACCENT } from '../../../src/quiz/constants/mazeStriker.constants';

/** The runtime's own deep-maze backdrop — the host matches it so letterboxing is invisible. */
const RUNTIME_BG = '#0B131A';

export const mazeStrikerViewStyles = StyleSheet.create({
  fullscreenContainer: {
    backgroundColor: RUNTIME_BG,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },

  // The game canvas fills the full available body — the runtime sizes itself to the viewport.
  canvasWrap: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: RUNTIME_BG,
  },

  backButton: {
    position: 'absolute',
    top: 8,
    left: 8,
    zIndex: 50,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'rgba(0,0,0,0.5)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backArrow: {
    color: '#F7FAFC',
    fontSize: 20,
    fontWeight: '800',
    marginTop: -2,
  },

  // Overlays cover the canvas for loading / error.
  overlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: 24,
    backgroundColor: 'rgba(11,19,26,0.82)',
  },
  message: { color: WARMUP_COLORS.textDim, fontSize: 14, fontWeight: '500', textAlign: 'center' },

  retryButton: {
    backgroundColor: MAZE_STRIKER_ACCENT,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  retryText: { color: WARMUP_COLORS.textOnBright, fontSize: 15, fontWeight: '800' },
  pressedDim: { opacity: 0.7 },
});
